// extracted by mini-css-extract-plugin
export default {"logoLink":"Logo_logoLink__oJ4LX","logo":"Logo_logo__6yrBi","borderTop":"Logo_borderTop__SY2r9","borderBottom":"Logo_borderBottom__t7cZS","textContainer":"Logo_textContainer__mYORB"};